/**
 * A utility function that computes offset for an event with respect to an origin time.
 * For example, offsets with respect to fluidBootstrapperStartTime or hostScenarioStartTime.
 * @param eventTime The raw timestamp value which should be converted to a relative timestamp.
 * @param originTime The moment in time against which the offset should be computed. This corresponds to an offset of time zero.
 */
export const computeOffsetTime = (eventTime?: number, originTime?: number) => {
  if (eventTime !== undefined && originTime !== undefined) {
    return eventTime - originTime;
  }
  return undefined;
};
